@if (hasPhotos && photos && photos.length > 0) {
  <div class="inline-carousel">
    <div #frame
         class="inline-carousel__frame"
         (pointerdown)="onPointerDown($event)"
         (pointermove)="onPointerMove($event)"
         (pointerup)="onPointerUp($event)"
         (pointercancel)="onPointerUp($event)"
         (pointerleave)="onPointerUp($event)"
    >
      <div class="inline-carousel__track"
           [class.inline-carousel__track--dragging]="dragging"
           [style.transform]="trackTransform"
      >
        @for (photo of photos; track photo.id ?? photo.url ?? i; let i = $index) {
          <div class="inline-carousel__slide">
            <app-image
              [src]="photo?.url ?? ''"
              [alt]="'Photo ' + ((photo?.id ?? i + 1))"
              preset="card"
              aspectRatio="4/3"
              [sizes]="'(max-width: 768px) 100vw, 520px'"
              [width]="520"
              [height]="390"
              (click)="openFullscreen(i)"
            ></app-image>
          </div>
        }
      </div>
      <button type="button"
              class="inline-carousel__control inline-carousel__control--prev"
              (click)="prev()">
        <i class="fa-solid fa-chevron-left"></i>
      </button>
      <button type="button"
              class="inline-carousel__control inline-carousel__control--next"
              (click)="next()">
        <i class="fa-solid fa-chevron-right"></i>
      </button>
      <div class="inline-carousel__count">{{activeIndex + 1}} / {{photos.length}}</div>
    </div>
  </div>
}

<app-carousel
  [open]="fullscreen"
  [photos]="photos"
  [index]="activeIndex"
  (onClose)="closeFullscreen()"
></app-carousel>
